var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReduccionDemandaAcumulada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 41,
    viewBox: "0 0 34 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-reduccion-demanda-acumulada"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reduccion-demanda-acumulada",
    clipPath: "url(#clip-reduccion-demanda-acumulada)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1059",
    "data-name": "Grupo 1059",
    transform: "translate(22705 2565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_41",
    "data-name": "Sustracci\\xF3n 41",
    d: "M3.768,34.645h0V17.832H0L5.684,0H18.431L13.514,9.773h4.917L3.768,34.644ZM8.236,2.279h0L3.476,15.387H6.319V25.854L14.383,12.2H9.477l5.195-9.922H8.236Z",
    transform: "translate(-22702.871 -2563.418)",
    fill: "#225B2A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1044",
    "data-name": "Grupo 1044",
    transform: "translate(-22694 -2552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_788",
    "data-name": "Grupo 788",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_171",
    "data-name": "Elipse 171",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#43A7B6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic_trending_up_24px",
    d: "M44.765,15.835l2.252-2.252-4.8-4.8-3.934,3.934L33.973,8.376,35.359,6.99l2.924,2.944L42.217,6l6.2,6.186,2.252-2.252v5.9Z",
    transform: "translate(-32.286 -0.325)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduccionDemandaAcumulada);
export default __webpack_public_path__ + "static/media/reduccion-demanda-acumulada.6652969163aec3704ad91fe06036061b.svg";
export { ForwardRef as ReactComponent };